<template>
  <div
    id="media"
    class="media"
  >
    <v-toolbar class="elevation-0 transparent media-toolbar">
      <v-btn
        flat
        @click="AddNew"
      >
        <v-icon color="primary">add</v-icon>
        &nbsp; New Task &nbsp;
      </v-btn>
      &nbsp;
        <v-text-field
        class="mx-3"
        flat
        label="Search"
        prepend-icon="search"
        v-model="search"
        clearable
        @click:clear="clearSearch"
      ></v-text-field>
      <v-autocomplete
        @change="filteByStatus"
        flat
        multiple
        :items="taskStatus"
        v-model="multipleStatusCodeID"
        label="Filter Status"
        chips
        prepend-icon="tune"
        item-text="status"
        item-value="statusCodeID"
      ></v-autocomplete>
      <!-- <v-autocomplete
        @change="filteByAssign"
        flat
        :items="taskAssignee"
        v-model="assigneeCodeID"
        label="Filter Assignee"
        chips
        prepend-icon="assignment_ind"
        item-text="status"
        item-value="statusCodeID"
      ></v-autocomplete> -->

      <v-menu
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        v-model="menuSearch"
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <v-btn
          slot="activator"
          icon
        >
          <v-icon>filter_list</v-icon>
        </v-btn>
        <vue-perfect-scrollbar
          class="chat-room--scrollbar lighten-5"
          v-bind:style="computeHeight"
        >
          <v-card>

            <v-container fluid>
              <v-layout
                row
                wrap
              >
                <v-flex
                  lg12
                  sm12
                >
                  <div class="mt-3 title">Search and Filter</div>
                </v-flex>
                <v-flex
                  lg6
                  sm6
                >
                  <v-text-field
                    label="Task Name"
                    prepend-icon="tune"
                    v-model="taskSearch.title"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  lg1
                  sm1
                  xs1
                >
                </v-flex>
                <v-flex
                  lg6
                  sm6
                  xs6
                >
                  <div class="mt-3 title">Assign Type</div>
                  <v-radio-group
                    v-model="taskSearch.assignTypeIds"
                    column
                  >
                    <v-radio
                      v-for="n in taskAssignee"
                      :key="n"
                      :label="n.status"
                      :value="n.statusCodeID"
                    ></v-radio>

                  </v-radio-group>
                </v-flex>
                <v-flex
                  lg6
                  sm6
                  xs6
                >
                  <div class="mt-3 title">Filter Status</div>
                  <v-radio-group
                    v-model="taskSearch.statusIds"
                    column
                  >
                    <v-radio
                      v-for="n in taskStatus"
                      :key="n"
                      :label="n.status"
                      :value="n.statusCodeID"
                    ></v-radio>

                  </v-radio-group>
                </v-flex>
                <v-flex
                  lg6
                  sm6
                  xs6
                >
                  <div class="mt-3 title">Work Type</div>
                  <v-radio-group
                    v-model="taskSearch.workTypeIds"
                    column
                  >
                    <v-radio
                      v-for="n in workTypeItems"
                      :key="n"
                      :label="n.status"
                      :value="n.statusCodeID"
                    ></v-radio>

                  </v-radio-group>
                </v-flex>
                <v-flex
                  lg6
                  sm6
                  xs6
                >
                  <div class="mt-3 title">Request Type</div>
                  <v-radio-group
                    v-model="taskSearch.requestTypeIds"
                    column
                  >
                    <v-radio
                      v-for="n in requestTypeItems"
                      :key="n"
                      :label="n.status"
                      :value="n.statusCodeID"
                    ></v-radio>

                  </v-radio-group>
                </v-flex>
                <v-flex
                  lg5
                  sm5
                  xs5
                >
                  <div class="mt-3 title">Project</div>
                  <v-autocomplete
                    hint="Atleast 3 Characters required"
                    :loading="loader"
                    flat
                    :items="projectItems"
                    label="Project"
                    chips
                    required
                    item-text="name"
                    item-value="projectID"
                    v-model="taskSearch.projectIds"
                  >

                  </v-autocomplete>
                </v-flex>
                <v-flex
                  lg1
                  sm1
                  xs1
                >
                </v-flex>
                <v-flex
                  lg5
                  sm5
                  xs5
                >
                  <div class="mt-3 title">Tags</div>
                  <v-autocomplete
                    hint="Atleast 3 Characters required"
                    :loading="loader"
                    flat
                    :items="tagItems"
                    label="Tag"
                    chips
                    multiple
                    item-text="name"
                    item-value="tagMasterID"
                    v-model="taskSearch.tagIds"
                  >

                  </v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                outline
                color="grey"
                @click="menuSearch = false"
              >Cancel</v-btn>
              <v-btn
                outline
                color="primary"
                @click="taskSearchFilter"
              >Search</v-btn>
            </v-card-actions>

          </v-card>
        </vue-perfect-scrollbar>
      </v-menu>
      <v-menu
        :close-on-content-click="true"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <v-btn
          slot="activator"
          icon
        >
          <v-icon>sort</v-icon>
        </v-btn>

        <v-list>
          <v-subheader>
            Sorting by Title and Date
          </v-subheader>
          <v-list-tile
            v-for="(item, i) in sortItems"
            :key="i"
            @click="sortTask(item.statusCodeID)"
          >
            <v-list-tile-title>{{ item.status }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-spacer></v-spacer>
      <v-btn-toggle v-model="view">
        <v-btn
          flat
          value="list"
        >
          <v-icon color="primary">view_headline</v-icon>
        </v-btn>
        <v-btn
          flat
          value="grid"
        >
          <v-icon color="primary">calendar_today</v-icon>
        </v-btn>
      </v-btn-toggle>
    </v-toolbar>
    <v-divider></v-divider>
    <div class="layout row media-layout">
      <div class="media-content flex transparent">
        <app-section-loader :status="loader"></app-section-loader>

        <v-container
          fluid
          v-if="view ==='grid'"
        >
          <v-layout
            row
            wrap
            class="x-grid-lg"
          >
            <v-flex
              lg12
              sm12
              xs12
            >
              <full-calendar
                class="fullwidth"
                :events="filteredItems"
                @dayClick="handleDayClick"
                @eventClick="handleEventClick"
              >
              </full-calendar>
            </v-flex>

          </v-layout>
        </v-container>
        <v-layout
          column
          v-else
        >

          <v-data-table
            :items="filteredItems"
            class="elevation-1"
            :headers="headers"
            ref="sortableTable"
            fix-header
          >
            <template
              slot="items"
              slot-scope="props"
            >
              <tr
                class="sortableRow"
                :key="itemKey(props.item)"
              >
                <td
                  class="px-1"
                  style="width: 0.1%"
                >
                  <v-btn
                    style="cursor: move"
                    icon
                    class="sortHandle"
                  >
                    <v-icon>drag_handle</v-icon>
                  </v-btn>
                </td>
                <td class="justify-center layout px-0">
                  <v-icon
                    color="green"
                    v-if="props.item.isUrgent"
                    small
                  >add_alert</v-icon>
                  <v-icon
                    v-else
                    color="transparent"
                    small
                  >add_alert</v-icon>

                  <v-icon
                    small
                    color="green"
                    v-if="props.item.overDueAllowed"
                  >done</v-icon>
                  <v-icon
                    v-else
                    color="transparent"
                    small
                  >done</v-icon>
                  <v-icon
                    v-else
                    color="red"
                    small
                    v-if="props.item.followUp"
                  >priority_high</v-icon>
                  <v-icon
                    v-else
                    color="transparent"
                    small
                  >priority_high</v-icon>
                </td>

                <td class="text-xs-left">
                  <span
                    v-if="props.item.isRead == false"
                    style="font-weight:bold"
                  >{{ props.item.title }}</span>
                  <span v-else>{{ props.item.title }}</span>
                </td>
                <td class="text-xs-left">{{ props.item.addedByUser }}</td>
                <td class="text-xs-left">{{ props.item.userNames }}</td>

                <td class="text-xs-left">{{ props.item.onBehalfName}}</td>
                <td class="text-xs-left">{{ props.item.workType }}</td>
                <td class="text-xs-left">{{ props.item.requestType }}</td>

                <td class="text-xs-left">{{ props.item.dueDate | formatDate}}</td>

                <!-- <td class="text-xs-left">
                  <v-badge
                    class="warning"
                    v-if="props.item.statusCodeID == 511"
                  >Draft</v-badge>
                  <v-badge
                    class="success"
                    v-if="props.item.statusCodeID == 512"
                  >Assigned</v-badge>
                  <v-badge
                    class="success"
                    v-if="props.item.statusCodeID == 513"
                  >Completed</v-badge>
                  <v-badge
                    color="red"
                    v-if="props.item.overDueAllowed == 'True'"
                  ><span slot="badge">!</span></v-badge>

                </td> -->
                <!-- <td class="text-xs-left">
                  <v-chip
                    v-for="(tag,index) in props.item.tagNames"
                    :key="'list-file-'+index"
                    label
                    small
                    color="grey"
                    text-color="white"
                  >
                      <v-icon left>label</v-icon> # {{tag}}
                  </v-chip>
                </td> -->
                <!-- <td
                  class="text-xs-left"
                  v-if="props.item.taskNote !=null"
                >{{ props.item.taskNote.remainderDate | formatDate}}</td>
                <td v-else>

                </td> -->
                <td class="justify-center layout px-0">
                  <v-icon
                    small
                    class="mr-2"
                    @click="redirectLink(props.item.mainTaskId)"
                  >
                    visibility
                  </v-icon>
                  <v-edit-dialog
                    class="text-xs-right"
                    large
                    lazy
                    @save="saveNote(props.item)"
                    @open="openNote(props.item)"
                  >
                    <v-icon
                      class="mr-2"
                      small
                    >message</v-icon>

                    <div
                      slot="input"
                      class="mt-3 title"
                    >Personal notes & Reminder.</div>
                    <v-container
                      fluid
                      grid-list-md
                      slot="input"
                    >
                      <v-layout
                        row
                        wrap
                      >

                        <v-flex
                          lg11
                          sm11
                        >
                          <v-textarea
                            label="Notes"
                            prepend-icon="note"
                            counter
                            v-model="taskNote.notes"
                          ></v-textarea>
                        </v-flex>
                        <v-flex
                          lg5
                          sm5
                        >
                          <v-text-field
                            v-model="taskNote.remainderDate"
                            label="Reminder Date"
                            prepend-icon="event"
                            type="date"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-edit-dialog>
                  <v-edit-dialog
                    class="text-xs-right"
                    large
                    lazy
                    @save="saveDiscussion(props.item)"
                    @open="openDiscussion(props.item)"
                  >
                    <v-icon
                      class="mr-2"
                      small
                    >calendar_today</v-icon>

                    <div
                      slot="input"
                      class="mt-3 title"
                    >Discussion Date </div>
                    <v-container
                      fluid
                      grid-list-md
                      slot="input"
                    >
                      <v-layout
                        row
                        wrap
                      >

                        <v-flex
                          lg11
                          sm11
                        >
                          <v-text-field
                            v-model="taskDiscussion.discussionDate"
                            label="Discussion Date"
                            prepend-icon="event"
                            type="date"
                          ></v-text-field>
                        </v-flex>
                        <v-flex
                          lg11
                          sm11
                        >
                          <v-textarea
                            v-model="taskDiscussion.discussionNotes"
                            label="Discussion Notes"
                            prepend-icon="description"
                          >
                          </v-textarea>
                        </v-flex>
                        <!-- <v-flex
                          lg5
                          sm5
                        >
                          <v-autocomplete
                      label="Users"
                      prepend-icon="group"
                      v-model="taskDiscussion.userIds"
                      :items="userItems"
                      multiple
                      flat
                      chips
                      auto
                      item-text="userName"
                      item-value="userID"
                    >
                    </v-autocomplete>
                        </v-flex> -->
                      </v-layout>
                    </v-container>
                  </v-edit-dialog>
                  <!-- </td>
                <v-spacer></v-spacer>
                <td> -->
                  <v-edit-dialog
                    class="text-xs-right"
                    large
                    lazy
                    @save="savetag(props.item)"
                    @open="openTag(props.item)"
                  >
                    <v-icon
                      class="mr-2"
                      small
                    >label</v-icon>

                    <div
                      slot="input"
                      class="mt-3 title"
                    >Personal Tags.</div>
                    <v-container
                      fluid
                      grid-list-md
                      slot="input"
                    >
                      <v-layout
                        row
                        wrap
                      >

                        <v-flex
                          lg11
                          sm11
                        >
                          <v-combobox
                            :items="PersonaltagItems"
                            label="Personal Tags"
                            v-model="personalTag.tags"
                            multiple
                            prepend-icon="filter_vintage"
                          >
                            <template
                              slot="selection"
                              slot-scope="data"
                            >
                              <v-chip
                                :selected="data.selected"
                                close
                                class="chip--select-multi"
                                @input="removePTag(data.item)"
                              >
                                <v-avatar
                                  class="primary white--text"
                                  v-text="data.item.slice(0, 1).toUpperCase()"
                                ></v-avatar>
                                {{ data.item }}
                              </v-chip>
                            </template>
                            <template
                              slot="item"
                              slot-scope="data"
                            >
                              <template v-if="typeof data.item !== 'object'">
                                <v-list-tile-content v-text="data.item"></v-list-tile-content>
                              </template>
                              <template v-else>
                                <!-- <v-list-tile-avatar>
                  <img :src="data.item.avatar">
                </v-list-tile-avatar> -->
                                <v-list-tile-content>
                                  <v-list-tile-title v-html="data.item"></v-list-tile-title>
                                  <!-- <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title> -->
                                </v-list-tile-content>
                              </template>
                            </template>
                          </v-combobox>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-edit-dialog>
                  <v-icon
                    small
                    class="mr-2"
                    @click="showTaskDetail(props.item)"
                  >
                    edit
                  </v-icon>

                </td>

              </tr>
            </template>
          </v-data-table>

        </v-layout>

        <v-dialog
          v-model="dialog"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card>

            <v-toolbar
              card
              dense
              color="primary"
            >

              <v-btn
                color="white"
                outline
                @click.native="complete"
              >Complete </v-btn>

              <!-- <v-btn
                icon
                @click.native="dialog = false"
              >
                <v-icon color="white">reply</v-icon>
              </v-btn> -->

              <!-- <v-toolbar-title><h4>Details</h4></v-toolbar-title> -->
              <v-btn
                icon
                @click.native="saveAndClose"
              >
                <v-icon color="white">library_add</v-icon>
              </v-btn>

              <v-btn
                icon
                @click.native="save"
                :loading="loader"
              >
                <v-icon color="white">save</v-icon>
              </v-btn>
              <!-- <v-btn
                icon
                @click.native="add"
              >
                <v-icon color="white">add</v-icon>
              </v-btn> -->
              <v-btn
                icon
                @click.native="deleterow"
                :loading="loader"
              >
                <v-icon color="white">delete</v-icon>
              </v-btn>
              <!-- <v-btn
                icon
                @click.native="first"
              >
                <v-icon color="white">first_page</v-icon>
              </v-btn>
              <v-btn
                icon
                @click.native="next"
              >
                <v-icon color="white">keyboard_arrow_left</v-icon>
              </v-btn>
              <v-btn
                icon
                @click.native="previous"
              >
                <v-icon color="white">keyboard_arrow_right</v-icon>
              </v-btn>
              <v-btn
                icon
                @click.native="last"
              >
                <v-icon color="white">last_page</v-icon>
              </v-btn> -->
              <v-spacer></v-spacer>
              <v-dialog
                v-model="taskLinkDialog"
                max-width="700px"
                scrollable
              >
                <v-card>

                  <v-form
                    v-model="editedItem.valid"
                    ref="form"
                    lazy-validation
                  >
                    <v-card-title>
                      <span>Task Link</span>
                      <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-text>
                      <v-layout
                        row
                        wrap
                      >
                        <v-flex
                          lg12
                          sm12
                        >
                          <v-text-field
                            :loading="loader"
                            label="Task Name"
                            prepend-icon="tune"
                            v-model="editedItem.title"
                            readonly
                          ></v-text-field>

                          <v-autocomplete
                            hint="Atleast 3 Characters required"
                            :loading="loader"
                            flat
                            placeholder="Select only suggested Task Items"
                            :items="taskItems"
                            v-model="editedItem.taskLinkedIds"
                            label="Task Items"
                            auto
                            chips
                            multiple
                            prepend-icon="tune"
                            item-text="title"
                            item-value="taskID"
                          ></v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        outline
                        color="primary"
                        @click="taskLinkDialog = false"
                      >Close</v-btn>
                      <v-btn
                        outline
                        color="primary"
                        @click.native="taskLinksave"
                      >Save</v-btn>
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-dialog>

              <v-dialog
                v-model="taskDuplicateDialog"
                max-width="700px"
                scrollable
              >
                <v-card>

                  <v-form
                    v-model="editedItem.valid"
                    ref="formMerge"
                    lazy-validation
                  >
                    <v-card-title>
                      <span color="primary">Merge Duplicate Tasks</span>
                      <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-text>
                      <v-layout
                        row
                        wrap
                      >
                        <v-flex
                          lg12
                          sm12
                        >
                          <v-text-field
                            :loading="loader"
                            label="Task Name"
                            prepend-icon="tune"
                            v-model="editedItem.title"
                            readonly
                          ></v-text-field>

                          <v-autocomplete
                            hint="Atleast 3 Characters required"
                            :loading="loader"
                            flat
                            placeholder="Select only suggested Task Items"
                            :items="taskItems"
                            v-model="mergeTask.taskMergedIds"
                            label="Find a task"
                            auto
                            chips
                            multiple
                            prepend-icon="tune"
                            item-text="title"
                            item-value="taskID"
                          ></v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        outline
                        color="primary"
                        @click="taskDuplicateDialog = false"
                      >Close</v-btn>
                      <v-btn
                        outline
                        color="primary"
                        @click.native="taskDuplicatesave"
                      >Merge</v-btn>
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-dialog>
              <v-btn
                icon
                @click.native="taskDuplicateClick"
                v-if="actionButton"
              >
                <v-icon
                  icon
                  color="white"
                >mdi-anchor</v-icon>
              </v-btn>

              <v-btn
                icon
                @click.native="taskLinkClick"
                v-if="actionButton"
              >
                <v-icon
                  icon
                  color="white"
                >link</v-icon>
              </v-btn>

              <!-- <v-btn
                icon
                v-if="actionButton"
                @click.native="subTaskClick"
              >
                <v-icon
                  icon
                  color="white"
                >low_priority</v-icon>
              </v-btn> -->

              <v-menu
                bottom
                left
              >
                <v-list>
                  <v-list-tile
                    v-for="(item, i) in items"
                    :key="i"
                    click
                  >
                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
              <v-btn
                icon
                @click.native="close"
              >
                <v-icon color="white">close</v-icon>
              </v-btn>
            </v-toolbar>

            <task-tabform
              ref="reftasktabForm"
              v-bind="dialogData"
            ></task-tabform>

            <delete-confirmation-dialog
              ref="formdeleteConfirmationDialog"
              heading="Are You Sure You Want To Delete?"
              message="Are You Sure You Want To Delete This Item Permanently?"
              @onConfirm="formDeleteItem"
            >
            </delete-confirmation-dialog>

          </v-card>
        </v-dialog>
      </div>
    </div>
    <app-section-loader :status="loader"></app-section-loader>
  </div>
</template>

<script>
import FullCalendar from 'vue-fullcalendar';
import { getFileMenu, getFile } from '@/api/file';
import TaskTabform from '@/pages/task/taskTabform';
import SubTask from '@/pages/task/subtask';
import SubTaskList from '@/pages/task/subTaskList';
//import TaskEntry from '@/pages/task/taskEntry';
import UploadButton from 'vuetify-upload-button';
import GlobalMessage from '@/constant'
import { getApplicationUsers, getTaskSorting, updateRead, getSubTasksbyStatus, getTaskSearchFilter, getTaskAssigne, completeTask, getTaskMasters, getTaskAttachment, getTaskComments, createTaskComments, getSubTasksId, getProjects, getTagMaster, getPersonalTags, getPersonalTagsByUser, getTaskNotes, getTaskMaster, getDataSubTask, createTaskMaster, updateTaskMaster, createTaskNotes, createPersonalTags, updatePersonalTags, updateTaskNotes, createSubTaskMaster, updateSubTaskMaster, deleteTaskMaster, getTaskLinks, getDataTaskLink, createTaskLinks, updateTaskLink, deleteTaskLink, duplicateTask } from '@/api/taskMaster';
import { uploadDocuments } from '@/api/document';
import { getTaskAppointments, getTaskAppointment, getTaskAppointmentsByID, createTaskAppointment, updateTaskAppointment, deleteTaskAppointment, getDiscussionNotes } from '@/api/taskAppointment';
import Sortable from "sortablejs";

//import CKEditor from '@ckeditor/ckeditor5-vue';


export default {
  components: {
    FullCalendar,
    TaskTabform,
    SubTask,

    SubTaskList,
    'upload-btn': UploadButton
  },
  data: () => ({
    itemKeys: new WeakMap(),
    currentItemKey: 0,
    rowsPerPageItems: [10, 20, 30, 40],
    pagination: {
      rowsPerPage: 20
    },
    taskSearch: {
      title: '',
      assignTypeIds: -1,
      statusIds: -1,
      workTypeIds: -1,
      requestTypeIds: -1,
      projectIds: -1,
      tagIds: [],
      userId: -1,
    },
    personalTags: [
      'Programming',
      'Design',
      'Vue',
      'Vuetify'
    ],
    menureminder: false,

    menuSearch: false,
    taskMenus: [
      {
        icon: 'calendar_today',
        href: '#',
        title: 'Set Reminder',
        click: e => {

        }
      },
      {
        icon: 'note',
        href: '#',
        title: 'Personal Note',
        click: e => {

        }
      },
      {
        icon: 'low_priority',
        href: '#',
        title: 'Sub Task',
        click: e => {

        }
      }
    ],

    menufilter: false,

    size: 'lg',
    view: 'list',
    editedSubtaskIndex: -1,
    subTaskitems: [],
    actionButton: false,
    size: 'sm',
    picker: new Date().toISOString().substr(0, 10),
    dialog: false,
    dialogData: null,
    dialogSTData: null,
    folder: false,
    uploadFile: false,
    taskLinkDialog: false,
    taskDuplicateDialog: false,
    subTaskDialog: false,
    loader: false,
    deleteloader: false,
    search: '',
    assigneeCodeID: null,
    statusCodeID: 512,
    tagItems: [],
    userItems: [],
    PersonaltagItems: [],
    projectItems: [],
    multipleStatusCodeID: [512],
    items: [],
    sortItems: [
      { status: 'Oldest on Top', statusCodeID: 700 },
      { status: 'Newest on Top', statusCodeID: 701 },
      { status: 'Title(A-Z)', statusCodeID: 702 },
      { status: 'Title(Z-A)', statusCodeID: 703 }
    ],
    taskStatus: [
      { status: 'Draft', statusCodeID: 511 },
      { status: 'Assigned', statusCodeID: 512 },
      { status: 'Completed', statusCodeID: 513 },
      { status: 'Cancelled', statusCodeID: 514 },
      { status: 'Over Due', statusCodeID: 515 },
      { status: 'Closed', statusCodeID: 516 },
    ],
    taskAssignee: [
      { status: 'Assigned To Me', statusCodeID: 615 },
      { status: 'Assigned By', statusCodeID: 611 },
      { status: 'CC', statusCodeID: 612 },
      { status: 'Onbehalf', statusCodeID: 613 },

    ],
    workTypeItems: [
      { status: 'Job Assign', statusCodeID: 34 },
      { status: 'Wiki', statusCodeID: 35 },
      { status: 'Wiki', statusCodeID: 36 },
      { status: 'To Do List', statusCodeID: 37 },
      { status: 'Work Flow', statusCodeID: 38 },
      { status: 'Message', statusCodeID: 39 }],
    requestTypeItems: [
      { status: 'WorkFlow', statusCodeID: 47 },
      { status: 'Requestor', statusCodeID: 48 },
      { status: 'MySelf', statusCodeID: 49 },
      { status: 'New Page', statusCodeID: 50 },
      { status: 'Revision Page', statusCodeID: 51 },
      { status: 'Approval Required', statusCodeID: 52 },
      { status: 'SME Comment', statusCodeID: 53 },
      { status: 'Routine', statusCodeID: 54 },
      { status: 'Job Assign', statusCodeID: 55 },
      { status: 'Message', statusCodeID: 56 },
    ],

    taskItems: [],
    tagNames: [],
    taskComments: [],
    taskItemLink: [],
    taskcomment: { comment: '', taskMasterId: null, addedByUser: '', commentedDate: new Date() },
    searchItem: { action: '', Id: null, searchString: 'searchString', },
    searchsubTaskItem: { action: '', Id: null, searchString: 'searchString', },
    editedItem: {
      valid: false,
      taskID: -1,
      //taskNotesID: -1,
      parentTaskID: null,
      date: new Date().toISOString().substr(0, 10),
      title: '',
      assignedTo: [],
      dueDate: new Date().toISOString().substr(0, 10),
      description: '',
      projectID: null,
      assignedCC: [],
      onBehalfID: null,
      sessionID: '',
      addedByUserID: null,
      addedDate: new Date().toISOString().substr(0, 10),
      addedByUser: 'Arun',
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserID: null,
      modifiedDate: new Date().toISOString().substr(0, 10),
      discussionDate: new Date().toISOString().substr(0, 10),
      requiredfield: [v => !!v || 'This is required field'],
      tagMasterID: -1,
      tagIds: [],
      tag: '',
      addedByUser: 'Arun',
      taskItemLink: [],
      taskLinkedIds: [],
      attachments: [],
      taskLinkID: -1,
      onBehalfName: '',
      overDueAllowed: 'false',
      followUp: 'false',
      userNames: [],
    },
    defaultItem: {
      valid: false,
      taskID: -1,
      // taskNotesID: -1,
      parentTaskID: null,
      date: new Date().toISOString().substr(0, 10),
      title: '',
      assignedTo: [],
      dueDate: new Date().toISOString().substr(0, 10),
      description: '',
      projectID: null,
      assignedCC: [],
      onBehalfID: null,
      sessionID: '',
      addedByUserID: null,
      addedDate: new Date().toISOString().substr(0, 10),
      addedByUser: 'Arun',
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserID: null,
      modifiedDate: new Date().toISOString().substr(0, 10),
      discussionDate: new Date().toISOString().substr(0, 10),
      requiredfield: [v => !!v || 'This is required field'],
      tagMasterID: -1,
      tagIds: [],
      tag: '',
      addedByUser: 'Arun',
      taskItemLink: [],
      taskLinkedIds: [],
      taskLinkID: -1,
      subTaskitems: [],
      attachments: [],
      onBehalfName: '',
      overDueAllowed: 'false',
      followUp: 'false',
      userNames: [],
    },
    height: {
      type: String,
      default: null,
    },
    headers: [
      { text: '', value: 'drag', align: 'center', sortable: false, width: "1%" },
      { text: '    ', value: 'isUrgent', sortable: false, align: 'left', width: "0%" },
      // { text: 'No Overdue', value: 'nooverdue', sortable: false, align: 'left', width: "0%" },
      // { text: 'Follow up', value: 'followUp', sortable: false, align: 'left', width: "1%" },     
      { text: 'Name', value: 'name', sortable: false, align: 'left', width: "20%" },
      { text: 'Assigned By', value: 'addedByUser', sortable: false, align: 'left', width: "1%" },
      { text: 'Assigned To', value: 'userNames', sortable: false, align: 'left', width: "1%" },
      { text: 'On Behalf Of', value: 'onBehalfName', sortable: false, align: 'left', width: "1%" },
      { text: 'Work Type', value: 'WorkType', sortable: false, align: 'left', width: "10%" },
      { text: 'Request Type', value: 'RequestType', sortable: false, align: 'left', width: "20%" },

      { text: 'Due Date', value: 'ModifiedDate', sortable: false, align: 'left', width: "30%" },

      // { text: 'Reminder', value: 'remainder', sortable: false, },
      { text: 'Actions', value: 'actions', sortable: false, align: 'left' }
    ],

    taskNote: {
      notes: '',
      remainderDate: new Date().toISOString().substr(0, 10),
      taskID: null,
      taskUserID: null,
      dueDate: new Date().toISOString().substr(0, 10)
    },
    taskDiscussion: {

      taskAppointmentID: -1,
      discussionDate: new Date().toISOString().substr(0, 10),
      discussionNotes: '',
      taskMasterID: null,
      appointmentBy: null,
      closedDate: new Date().toISOString().substr(0, 10),
      statusCodeID: null,
      status: '',

    },
    personalTag: {      tags: [],
      addedDate: new Date().toISOString().substr(0, 10), addedByUserID: null, taskID: null, modifiedDate: new Date().toISOString().substr(0, 10), modifiedByUserID: null    },
    mergeTask: {      taskMergedIds: [],
      modifiedByUserID: null    },
  }),

  mounted () {
    /* eslint-disable no-new */
    new Sortable(
      this.$refs.sortableTable.$el.getElementsByTagName('tbody')[0],
      {
        draggable: '.sortableRow',
        handle: '.sortHandle',
        onEnd: this.dragReorder
      }
    )
  },


  computed: {
    computeDisabled: function () {
      return (this.taskcomment.comment.length == 0);
    },
    filteredItems () {

      return this.taskItems.filter(item => {
        if (!this.search) return this.taskItems;
        return (item.title.toLowerCase().includes(this.search.toLowerCase()));
      });
    },
    computeHeight () {
      return {
        height: this.height || ''
      };
    },
    sendKey () {

      return {
        // bind to hotkey 
        'enter': this.sendComment
      }
    },
    saveKey () {

      return {
        // bind to hotkey 
        'ctrl+s': this.save
      }
    }
  },

  created () {
    // window.getApp.$emit('INITIALIZE_TASK');
    window.getApp.$on('ENABLE_TASKACTION', () => {
      this.actionButton = true;
    });

    this.initialize();

  },
  beforeDestroy () {

    window.getApp.$off('INITIALIZE_TASK')
    window.getApp.$off('EDIT_TASK')
    window.getApp.$off('INITIALIZE_TASKFILE')
    window.getApp.$off('INITIALIZE_TASKCONVER')
    window.getApp.$off('INITIALIZE_SUBTASK')
    window.getApp.$off('EDIT_SUBTASK')
    window.getApp.$off('ADD_SUBTASK')
    window.getApp.$off('SAVE_SUBTASK')
    window.getApp.$off('ADD_MAINSUBTASK')
    window.getApp.$off('SEND_TASKOBJ')
    this.$eventHub.$off('INITIALIZE_TASKCONVER');

  },
  methods: {

    dragReorder ({ oldIndex, newIndex }) {
      const movedItem = this.taskItems.splice(oldIndex, 1)[0]
      this.taskItems.splice(newIndex, 0, movedItem)
    },
    itemKey (item) {
      if (!this.itemKeys.has(item)) this.itemKeys.set(item, ++this.currentItemKey)
      return this.itemKeys.get(item)
    },

    back () {
      this.view = 'grid';

    },
    clearSearch () {
      this.search = "";
    },
    initialize () {



      this.loader = true;
      let userId = this.$store.state.auth.userId;



      //console.log(userId);
      getTaskMasters(this.$store.state.auth.userId)
        .then(response => {
          this.taskItems = response.data;
          console.log(this.taskItems);
          this.loader = false;

        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });


      // getTaskNotes(-1, this.$store.state.auth.userId)
      //   .then(response1 => {
      //     this.taskNote = response1.data;

      //   })
      //   .catch(error => {
      //     this.loader = false;
      //     window.getApp.$emit('APP_API_ERROR', error);

      //   });

    },
    files () {

      return getSubTasksId(this.taskID);
    },
    getSubTask () {
      getSubTasksId(this.taskID)
        .then(response3 => {
          this.subTaskitems = response3.data;
          this.loader = false;

        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    getTaskComments () {
      getTaskComments(this.taskID)
        .then(response => {
          this.taskComments = response.data;
          this.loader = false;
          //console.log(this.taskComments);
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    sendComment () {
      if (this.taskcomment.comment.trim().length > 0) {
        this.taskcomment.taskMasterId = this.taskID;
        this.taskcomment.commentedBy = 2;
        this.taskcomment.addedByUser = "Arun";
        this.taskcomment.commentedDate = new Date();

        createTaskComments(this.taskcomment)
          .then(response => {
            this.taskComments.push(response.data);
            this.taskcomment.comment = '';
            this.loader = false;
          })
          .catch(error => {
            this.loader = false;
            window.getApp.$emit('APP_API_ERROR', error);
          });
      }
    },
    removePTag (item) {
      const index = this.personalTag.tags.indexOf(item)
      if (index >= 0) this.personalTag.tags.splice(index, 1)
    },
    AddNew () {
      //   this.subTaskitems = [];
      //   this.editedItem = this.defaultItem;
      this.actionButton = false;
      //   this.editedItem.date = new Date().toISOString().substr(0, 10);
      //   this.editedItem.dueDate = new Date().toISOString().substr(0, 10);
      //   this.$refs.reftaskForm.taskfiles = new FormData(),
      //     this.$refs.reftaskForm.uploadedFiles = [],
      //     this.$refs.reftaskForm.formdata = this.editedItem;
      //   this.$refs.reftaskForm.userItems = this.userItems;
      //   this.$refs.reftaskForm.tagItems = this.tagItems;
      //   this.$refs.reftaskForm.projectItems = this.projectItems;
      //   this.$refs.refsubtaskForm.projectItems = this.projectItems;
      //   this.$refs.refsubtaskForm.userItems = this.userItems;
      //   this.$refs.refsubtaskForm.tagItems = this.tagItems;

      this.dialog = true;
      this.editedIndex = -1;
      this.editedSubtaskIndex = -1;

      setTimeout(() => {
        window.getApp.$emit('INITIALIZE_TASK', new Date());
        window.getApp.$emit('DISABLE_TAB', true);
      }, 400);

    },
    handleDayClick (day, e) {
      // this.subTaskitems = [];
      // this.editedItem = this.defaultItem;
      // this.actionButton = false;
      // this.editedItem.date = new Date().toISOString().substr(0, 10);
      // this.editedItem.dueDate = day.toISOString().substr(0, 10);
      // this.$refs.reftaskForm.taskfiles = new FormData(),
      //   this.$refs.reftaskForm.uploadedFiles = [],
      //   this.$refs.reftaskForm.formdata = this.editedItem;
      // this.$refs.reftaskForm.userItems = this.userItems;
      // this.$refs.reftaskForm.tagItems = this.tagItems;
      // this.$refs.reftaskForm.projectItems = this.projectItems;
      // this.$refs.refsubtaskForm.projectItems = this.projectItems;
      // this.$refs.refsubtaskForm.userItems = this.userItems;
      // this.$refs.refsubtaskForm.tagItems = this.tagItems;
      //this.$refs.reftaskForm.subTaskitems = this.subTaskitems;
      this.dialog = true;
      this.editedIndex = -1;
      this.editedSubtaskIndex = -1;
      window.getApp.$emit('INITIALIZE_TASK', day);
      window.getApp.$emit('DISABLE_TAB', true);

    },
    formateDate (string) {
      return string ? new Date(string).toISOString().substr(0, 10) : '';
    },
    handleEventClick (e, event, pos) {
      this.editedItem = e;


      this.dialog = true;
      window.getApp.$emit('DISABLE_TAB', false);
      setTimeout(() => {
        window.getApp.$emit('EDIT_TASK', this.editedItem);
      }, 400);

      updateRead(e.taskID)
        .then(response => {

        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      //this.editedItem.subTaskitems=this.subTaskitems;
      // this.editedItem.date = new Date().toISOString().substr(0, 10);
      // this.editedItem.dueDate = this.formateDate(e.dueDate);
      // this.$refs.reftaskForm.formdata = this.editedItem;
      // this.$refs.reftaskForm.userItems = this.userItems;
      // this.$refs.reftaskForm.tagItems = this.tagItems;
      // this.$refs.reftaskForm.projectItems = this.projectItems;
      // this.$refs.refsubtaskForm.projectItems = this.projectItems;
      // this.$refs.refsubtaskForm.userItems = this.userItems;
      // this.$refs.refsubtaskForm.tagItems = this.tagItems;
      // this.editedIndex = this.taskItems.indexOf(e);
      // this.dialog = true;
      // this.$refs.reftaskForm.taskItems = this.taskItems;
      //this.$refs.reftaskForm.subTaskitems = this.subTaskitems;
      //console.log(this.subTaskitems);
      // this.$refs.reftaskForm.taskItemLink = this.taskItems;
      // this.taskID = this.editedItem.taskID;
      // this.$refs.reftaskForm.taskfiles = new FormData(),
      //   this.$refs.reftaskForm.uploadedFiles = [],
      //   this.$refs.reftaskForm.getAttachments(),
      this.actionButton = true;
      //this.getSubTask();
      //this.getTaskComments();
      // this.editedSubtaskIndex = this.subTaskitems.indexOf(e);
    },

    onDeleteItem (item) {
      this.$refs.deleteConfirmationDialog.openDialog();
      this.selectedItem = item;
    },
    deleteItem () {
      this.$refs.deleteConfirmationDialog.close();
      this.loader = true;
      let index = this.gridItems.indexOf(this.selectedItem);
      deleteTaskMaster(this.selectedItem)
        .then(() => {
          this.loader = false;
          this.selectedItem = null;
          this.gridItems.splice(index, 1);
          window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.DELETE);
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },

    saveAndClose () {
      this.save();
      this.close();
      this.editedItem = this.defaultItem;
    },
    openUpload () {
      this.add();
      this.uploadFile = true;
    },
    toolfunction () {
      getTaskMaster(this.searchItem)
        .then(response => {

          if (response.data.taskID != null) {
            this.editedItem = response.data;
            this.editedItem.date = new Date().toISOString().substr(0, 10);
            this.editedItem.loginUser = this.$store.state.auth.userName;
            this.editedItem.isLogin = 'yes-1';

            window.getApp.$emit('EDIT_TASK', this.editedItem);

            //this.$refs.reftaskForm.formdata = this.editedItem;

            let index = this.taskItems.map(item => item.taskID).indexOf(response.data.taskID)
            this.editedIndex = index;
          }
          else {
            window.getApp.$emit('APP_API_SUCCESS', 'No More Record to view');
          }
        })
        .catch(error => {
          // this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    first () {
      this.searchItem.action = 'First';
      this.searchItem.Id = this.$refs.reftasktabForm.$refs.reftaskForm.formdata.taskID;
      // this.selectedItem.searchString = 'first';
      this.toolfunction();
    },
    last () {
      this.searchItem.action = 'Last';
      this.searchItem.Id = this.$refs.reftasktabForm.$refs.reftaskForm.formdata.taskID;
      //this.selectedItem.searchString = 'last';

      this.toolfunction();
    },
    previous () {
      this.searchItem.action = 'Previous';
      this.searchItem.Id = this.$refs.reftasktabForm.$refs.reftaskForm.formdata.taskID;
      //this.selectedItem.searchString = 'previous';
      this.toolfunction();
    },
    next () {
      this.searchItem.action = 'Next';
      this.searchItem.Id = this.$refs.reftasktabForm.$refs.reftaskForm.formdata.taskID;
      // this.selectedItem.searchString = 'next';
      this.toolfunction();
    },
    attachFile () {
      this.uploadFile = true;
    },
    taskLinkClick () {

      this.taskLinkDialog = true;

      this.taskDuplicateDialog = false;
    },
    taskDuplicateClick () {

      this.taskDuplicateDialog = true;
      this.taskLinkDialog = false;
    },
    subTaskClick () {

      this.$refs.refsubtaskForm.formdata.valid = false;
      this.$refs.refsubtaskForm.formdata.taskID = -1;
      this.$refs.refsubtaskForm.formdata.parentTaskID = null;
      this.$refs.refsubtaskForm.formdata.date = new Date().toISOString().substr(0, 10);
      this.$refs.refsubtaskForm.formdata.title = '';
      this.$refs.refsubtaskForm.formdata.assignedTo = null;
      this.$refs.refsubtaskForm.formdata.dueDate = new Date().toISOString().substr(0, 10);
      this.$refs.refsubtaskForm.formdata.description = '';
      this.$refs.refsubtaskForm.formdata.projectID = null;
      this.$refs.refsubtaskForm.formdata.assignedCC = [];
      this.$refs.refsubtaskForm.formdata.onBehalfID = null;
      this.$refs.refsubtaskForm.formdata.sessionID = '';
      this.$refs.refsubtaskForm.formdata.addedByUserID = null;
      this.$refs.refsubtaskForm.formdata.addedDate = new Date().toISOString().substr(0, 10);
      this.$refs.refsubtaskForm.formdata.addedByUser = '';
      this.$refs.refsubtaskForm.formdata.statusCodeID = null;
      this.$refs.refsubtaskForm.formdata.statusCode = '';
      this.$refs.refsubtaskForm.formdata.modifiedByUserID = null;
      this.$refs.refsubtaskForm.formdata.modifiedDate = new Date().toISOString().substr(0, 10);
      this.$refs.refsubtaskForm.formdata.tagMasterID = null;
      this.$refs.refsubtaskForm.formdata.tagIds = [];
      // this.$refs.refsubtaskForm.taskItemLink = [];
      // this.$refs.refsubtaskForm.taskLinkedIds = [];
      // this.$refs.refsubtaskForm.taskLinkID = null;
      // this.$refs.refsubtaskForm.subTaskitems = [];
      // this.$refs.refsubtaskForm.attachments = [];
      this.editedSubtaskIndex = -1;
      this.subTaskDialog = true;
    },
    complete () {
      this.$refs.reftasktabForm.$refs.reftaskForm.loader = true;
      this.editedItem = this.$refs.reftasktabForm.$refs.reftaskForm.formdata;
      this.editedItem.statusCodeID = 513;
      completeTask(this.editedItem)
        .then(() => {
          this.$refs.reftasktabForm.$refs.reftaskForm.loader = false;
          window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.SAVE);
        })
        .catch(error => {
          this.$refs.reftasktabForm.$refs.reftaskForm.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    filteByStatus (value) {
      if (value != undefined) {
        this.taskItems = [];

        for (var prop in value) {
          this.loader = true;
          console.log(value[prop])
          getSubTasksbyStatus(value[prop], this.$store.state.auth.userId)
            .then(response => {
              for (var id in response.data) {
                this.taskItems.push(response.data[id]);
              }
              this.loader = false;
              //this.assigneeCodeID = -1;

            })
            .catch(error => {
              this.loader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        }
      }
    },
    filteByAssign (value) {
      this.loader = true;

      getTaskAssigne(value, this.$store.state.auth.userId)
        .then(response => {
          this.taskItems = response.data;
          this.loader = false;
          //this.statusCodeID = -1;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    // showDetail (file) {
    //   this.selectedFile = file;
    //   this.editedItem.date = new Date().toISOString().substr(0, 10);
    //   this.editedSubtaskIndex = this.subTaskitems.indexOf(file);
    //   this.editedItem = Object.assign({}, this.selectedFile);
    //   this.editedItem.dueDate = this.formateDate(file.dueDate);
    //   this.editedItem.editedSubtaskIndex = this.editedSubtaskIndex;
    //   this.$refs.refsubtaskForm.formdata = this.editedItem;
    //   this.subTaskDialog = true;

    //   //this.toolfunctionSubtask ();
    // },
    showTaskDetail (item) {

      this.editedItem = item;

      this.dialog = true;
      window.getApp.$emit('DISABLE_TAB', false);
      setTimeout(() => {
        window.getApp.$emit('EDIT_TASK', this.editedItem);
      }, 400);

      updateRead(item.taskID)
        .then(response => {

        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

      this.actionButton = true;
    },
    openDialog () {
      this.add();
      this.dialog = true;
      this.editedItem = this.defaultItem;
    },
    clearObj () {
      this.defaultItem.valid = false;
      this.defaultItem.taskID = null;
      this.defaultItem.parentTaskID = null;
      this.defaultItem.date = new Date().toISOString().substr(0, 10);
      this.defaultItem.title = '';
      this.defaultItem.assignedTo = null;
      this.defaultItem.dueDate = new Date().toISOString().substr(0, 10);
      this.defaultItem.description = '';
      this.defaultItem.projectID = null;
      this.defaultItem.assignedCC = [];
      this.defaultItem.onBehalfID = null;
      this.defaultItem.sessionID = '';
      this.defaultItem.addedByUserID = null;
      this.defaultItem.addedDate = new Date().toISOString().substr(0, 10);
      this.defaultItem.addedByUser = '';
      this.defaultItem.statusCodeID = null;
      this.defaultItem.statusCode = '';
      this.defaultItem.modifiedByUserID = null;
      this.defaultItem.modifiedDate = new Date().toISOString().substr(0, 10);
      this.defaultItem.tagMasterID = null;
      this.defaultItem.tagIds = [];
      this.defaultItem.taskItemLink = [];
      this.defaultItem.taskLinkedIds = [];
      this.defaultItem.taskLinkID = null;
      this.defaultItem.subTaskitems = [];
      this.defaultItem.attachments = [];
    },
    add () {

      this.clearObj();

      this.editedItem = this.defaultItem;
      this.$refs.reftasktabForm.$refs.reftaskForm.formdata = this.editedItem;
      this.editedIndex = -1;
    },
    deleterow () {
      this.$refs.formdeleteConfirmationDialog.openDialog();
    },
    formDeleteItem () {
      this.$refs.formdeleteConfirmationDialog.close();
      // this.loader = true;
      let index = this.editedIndex;

      deleteTaskMaster(this.$refs.reftasktabForm.$refs.reftaskForm.formdata)
        .then(response => {
          this.close();
          this.taskItems.splice(index, 1);
          window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.DELETE);

        })
        .catch(error => {
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    close () {
      this.dialog = false;
      setTimeout(() => {
        this.initialize();
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;

        // window.getApp.$off('EDIT_TASK')
        // window.getApp.$off('INITIALIZE_TASKFILE')
        // window.getApp.$off('INITIALIZE_TASKCONVER')
        // window.getApp.$off('INITIALIZE_SUBTASK')
        // window.getApp.$off('SEND_TASKOBJ')

      }, 400);
    },
    save () {

      window.getApp.$emit('SAVE_TASK');

      //   this.editedItem = this.$refs.reftaskForm.formdata;
      //   this.actionButton = true;
      //   if (this.$refs.reftaskForm.$refs.validateform.validate()) {
      //     this.loader = true;
      //     this.$refs.reftaskForm.loader = true;
      //     let index = this.editedIndex;
      //     if (this.editedIndex > -1) {
      //       Object.assign(this.taskItems[this.editedIndex], this.editedItem);
      //       this.editedItem.modifiedByUserId = this.$store.state.auth.userId;
      //       this.editedItem.modifiedDate = new Date();
      //       this.editedItem.addedByUserId = this.$store.state.auth.userId;
      //       this.editedItem.addedDate = new Date();
      //       updateTaskMaster(this.editedItem)
      //         .then(response => {
      //           Object.assign(this.taskItems[index], response.data);
      //           this.loader = false;
      //           //this.snackbar = true;
      //           this.$refs.reftaskForm.loader = false;
      //           // this.snackbarMessage = 'Record Updated Successfully';
      //           taskLinkDialog: false;
      //           this.actionButton = true;
      //           window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.UPDATE);
      //         })
      //         .catch(error => {
      //           this.loader = false;
      //           this.$refs.reftaskForm.loader = false;
      //           // this.snackbar = true;
      //           // this.snackbarMessage = 'Failed to update record.';
      //           //this.$refs.reftaskForm.$refs.bomform.loader = false;
      //           window.getApp.$emit('APP_API_ERROR', error);
      //         });
      //     } else {
      //       this.editedItem.taskID = parseInt(Math.random() * 100) + 1024; // mock a id
      //       this.editedItem.addedByUserId = this.$store.state.auth.userId;
      //       this.editedItem.addedDate = new Date();
      //       this.editedItem.statusCodeID = 512;
      //       createTaskMaster(this.editedItem)
      //         .then(response => {
      //           this.taskItems.push(response.data);
      //           this.loader = false;
      //           // this.snackbar = true;
      //           this.$refs.reftaskForm.loader = false;
      //           this.editedItem = response.data;
      //           let index = this.taskItems.map(item => item.taskID).indexOf(response.data.taskID)
      //           this.editedIndex = index;
      //           // this.snackbarMessage = 'Record Saved Successfully';
      //           this.actionButton = true;
      //           window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.SAVE);
      //         })
      //         .catch(error => {
      //           this.loader = false;
      //           //this.snackbar = true;
      //           this.$refs.reftaskForm.loader = false;
      //           // this.snackbarMessage = 'Failed to insert record.';
      //           window.getApp.$emit('APP_API_ERROR', error);
      //         });
      //     }
      //     //this.close();
      //   }
      //   else {
      //     window.getApp.$emit('APP_API_VAL', GlobalMessage.VALIDATE);
      //   }
    },
    taskLinksave () {
      //this.editedItem = this.$refs.reftaskForm.formdata;

      // if (this.form.validate()) {
      this.loader = true;
      let index = this.editedIndex;
      createTaskLinks(this.editedItem)
        .then(response => {
          this.taskItems.push(response.data);
          this.loader = false;
          this.editedItem = response.data;
          let index = this.taskItems.map(item => item.taskID).indexOf(response.data.taskID)
          this.editedIndex = index;
          window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.SAVE);
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    taskDuplicatesave () {

      // if (this.form.validate()) {
      this.loader = true;
      this.mergeTask.modifiedByUserID = this.$store.state.auth.userId;

      let index = this.editedIndex;
      //this.taskMergeIds = this.editedItem.taskMergeIds;     
      //console.log(this.taskMergeIds);

      duplicateTask(this.mergeTask)
        .then(response => {

          window.getApp.$emit('APP_API_SUCCESS', "Duplicate Task Saved.... ");
          this.taskDuplicateDialog = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    closeSubTask () {
      this.dialog = false;
      this.editedItem = this.defaultItem;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedSubtaskIndex = -1;
      }, 300);
    },
    saveAndCloseSubTask () {
      this.saveSubTask();
      this.subTaskDialog = false;
      this.editedItem = this.defaultItem;

    },
    toolfunctionSubtask () {
      getDataSubTask(this.searchsubTaskItem)
        .then(response1 => {

          if (response1.data.taskID != null) {

            this.editedItem = response1.data;
            this.editedItem.date = new Date().toISOString().substr(0, 10);
            this.editedItem.loginUser = this.$store.state.auth.userName;
            this.editedItem.isLogin = 'yes-1';

            this.$refs.reftasktabForm.$refs.refsubtaskForm.formdata = this.editedItem;
            let index = this.subTaskitems.map(item => item.taskID).indexOf(response1.data.taskID)
            this.editedSubtaskIndex = index;
          }
          else {
            window.getApp.$emit('APP_API_SUCCESS', 'No more records to view');
          }
        })
        .catch(error => {
          // this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    firstSubTask () {
      this.searchsubTaskItem.action = 'First';
      this.searchsubTaskItem.Id = this.$refs.reftasktabForm.$refs.refsubtaskForm.formdata.taskID;
      // this.selectedItem.searchString = 'first';
      this.toolfunctionSubtask();
    },
    lastSubTask () {
      this.searchsubTaskItem.action = 'Last';
      this.searchsubTaskItem.Id = this.$refs.reftasktabForm.$refs.refsubtaskForm.formdata.taskID;
      //this.selectedItem.searchString = 'last';

      this.toolfunctionSubtask();
    },
    previousSubTask () {
      this.searchsubTaskItem.action = 'Previous';
      this.searchsubTaskItem.Id = this.$refs.reftasktabForm.$refs.refsubtaskForm.formdata.taskID;
      //this.selectedItem.searchString = 'previous';
      this.toolfunctionSubtask();
    },
    nextSubTask () {
      this.searchsubTaskItem.action = 'Next';
      this.searchsubTaskItem.Id = this.$refs.reftasktabForm.$refs.refsubtaskForm.formdata.taskID;
      // this.selectedItem.searchString = 'next';
      this.toolfunctionSubtask();
    },
    // fileChangedSubtask (file) {
    //   console.log(file);
    //   this.editedItem.fileName = file.name;
    //   this.editedItem.fileSize = file.size;
    //   this.editedItem.contentType = file.type;
    //   this.files.append("file", file, file.name);
    // },
    addSubTask () {
      this.editedItem = this.defaultItem;
      this.$refs.reftasktabForm.$refs.refsubtaskForm.formdata = this.editedItem;
      this.editedSubtaskIndex = -1;
    },
    deleterowSubTask () {
      this.$refs.formSubTaskdeleteConfirmationDialog.openDialog();
    },
    formSubTaskDeleteItem () {
      this.$refs.formSubTaskdeleteConfirmationDialog.close();
      // this.loader = true;
      let index = this.editedSubtaskIndex;

      deleteTaskMaster(this.$refs.reftasktabForm.$refs.refsubtaskForm.formdata)
        .then(() => {
          this.add();
          this.taskItems.splice(index, 1);
          window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.DELETE);
        })
        .catch(error => {
          window.getApp.$emit('APP_API_ERROR', error);

        });
    },
    saveSubTask () {
      this.editedItem = this.$refs.reftasktabForm.$refs.refsubtaskForm.formdata;


      if (this.$refs.reftasktabForm.$refs.refsubtaskForm.$refs.validateform.validate()) {
        let index = this.editedSubtaskIndex;
        if (this.editedSubtaskIndex > -1) {
          Object.assign(this.subTaskitems[this.editedSubtaskIndex], this.editedItem);
          this.editedItem.modifiedByUserId = this.$store.state.auth.userId;
          this.editedItem.modifiedDate = new Date();
          this.editedItem.addedByUserId = this.$store.state.auth.userId;
          this.editedItem.addedDate = new Date();
          this.editedItem.parentTaskID = this.taskID;

          updateSubTaskMaster(this.editedItem)
            .then(response => {
              Object.assign(this.subTaskitems[index], response.data);
              this.loader = false;
              window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.UPDATE);

            })
            .catch(error => {
              this.loader = false;
              window.getApp.$emit('APP_API_ERROR', error);
              //this.$refs.reftaskForm.$refs.bomform.loader = false;
            });
        } else {
          this.editedItem.taskID = parseInt(Math.random() * 100) + 1024; // mock a id
          this.editedItem.addedByUserId = this.$store.state.auth.userId;
          this.editedItem.addedDate = new Date();
          this.editedItem.statusCodeID = 512;
          this.editedItem.parentTaskID = this.taskID;
          //console.log(this.editedItem);

          createSubTaskMaster(this.editedItem)
            .then(response => {
              this.editedItem.taskID = response.data.taskID;
              this.subTaskitems.push(response.data);
              this.loader = false;
              this.editedItem = response.data;
              let index = this.subTaskitems.map(item => item.taskID).indexOf(response.data.taskID)
              this.editedSubtaskIndex = index;

              window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.SAVE);
            })
            .catch(error => {
              this.loader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        }
        //this.close();
      }
      else {
        // console.log('Validation failed.')
      }
    },
    savetag (item) {
      //console.log(item);
      //this.editedItem.tags = item.tags;
      //console.log(this.$store.state.auth.userId);

      this.personalTag.taskID = item.taskID;
      this.personalTag.tags = item.tags;
      this.personalTag.addedDate = new Date().toISOString().substr(0, 10);
      this.personalTag.addedByUserID = this.$store.state.auth.userId;
      console.log(this.personalTag)
      createPersonalTags(this.personalTag)
        .then(response => {
          this.personalTag = response.data;
          window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.SAVE);
        })
        .catch(error => {
          this.loader = false;
          //this.snackbar = true;
          this.$refs.reftasktabForm.$refs.reftaskForm.loader = false;

          window.getApp.$emit('APP_API_ERROR', error);
        });


      //window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.SAVE);
    },
    saveNote (item) {

      //console.log(item);
      this.taskNote.taskNotesID = -1;
      this.taskNote.taskID = item.taskID;
      this.taskNote.taskUserID = this.$store.state.auth.userId;
      this.taskNote.modifiedDate = new Date();
      this.taskNote.remainderDate = new Date();
      console.log(this.taskNote);
      createTaskNotes(this.taskNote)
        .then(response => {
          this.taskNote = response.data;
          window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.SAVE);
        })
        .catch(error => {
          this.loader = false;
          //this.snackbar = true;
          this.$refs.reftasktabForm.$refs.reftaskForm.loader = false;

          window.getApp.$emit('APP_API_ERROR', error);
        });

    },
    saveDiscussion (item) {
      //this.taskDiscussion=[];
      this.taskDiscussion.discussionDate = this.formateDate(new Date().toISOString().substr(0, 10));
      this.taskDiscussion.closedDate = this.formateDate(new Date().toISOString().substr(0, 10));
      //this.taskDiscussion.taskAppointmentID = -1;
      // this.taskDiscussion.discussionNotes = item.discussionNotes;
      this.taskDiscussion.appointmentBy = this.$store.state.auth.userId;
      this.taskDiscussion.taskMasterID = item.taskID;
      console.log(this.taskDiscussion);
      createTaskAppointment(this.taskDiscussion)
        .then(response => {
          console.log(response.data);
          window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.SAVE);
        })
        .catch(error => {
          this.loader = false;
          //this.snackbar = true;
          this.$refs.reftasktabForm.$refs.reftaskForm.loader = false;

          window.getApp.$emit('APP_API_ERROR', error);
        });

    },
    cancelNote () {
      window.getApp.$emit('APP_API_SUCCESS', 'cancel note');
    },
    closeNote () {
      window.getApp.$emit('APP_API_SUCCESS', 'close note');
    },
    openTag (item) {
      this.personalTag.tags = [];
      //console.log(item);
      item.addedByUserID = this.$store.state.auth.userId;
      console.log(item.addedByUserID);
      getPersonalTagsByUser(item.addedByUserID)
        .then(response => {
          this.PersonaltagItems = response.data;
          // this.personalTag.tags = response.data;
          for (var id in response.data) {
            this.personalTag.tags.push(response.data[id]);
          }
          // this.loader = false;
          console.log(response.data);
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);

        });

    },
    openNote (item) {
      // console.log(item);
      this.taskNote = [];
      this.taskNote.remainderDate = this.formateDate(new Date().toISOString().substr(0, 10));
      item.addedByUserID = this.$store.state.auth.userId;
      // console.log(this.$store.state.auth.userId);
      getTaskNotes(item.taskID, item.addedByUserID)
        .then(response => {
          if (response.data.remainderDate != undefined) {
            this.taskNote = response.data;
            this.taskNote.remainderDate = this.formateDate(this.taskNote.remainderDate);
          }
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);

        });

    },
    taskSearchFilter () {
      this.loader = true;
      this.taskSearch.userId = this.$store.state.auth.userId;

      getTaskSearchFilter(this.taskSearch)
        .then(response => {

          this.taskItems = response.data;
          this.menuSearch = false;
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

    },
    sortTask (value) {    this.loader = true;

      getTaskSorting(value, this.$store.state.auth.userId)
        .then(response => {

          this.taskItems = response.data;
          this.menuSearch = false;
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });    },
    openDiscussion (item) {

      //console.log(item);
      this.taskID = item.taskID;
      item.addedByUserID = this.$store.state.auth.userId;
      console.log(item.addedByUserID);
      getTaskAppointmentsByID(this.taskID, item.addedByUserID)
        .then(response3 => {
          this.taskDiscussion = response3.data;
          // this.personalTag.tags = response.data;

          // this.loader = false;
          console.log(this.taskDiscussion);
          console.log(response3.data);
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);

        });



    },
    redirectLink (mainTaskId) {

      // let routeData = this.$router.resolve({ name: 'taskTreeView', query: { id: mainTaskId } });
      // console.log(routeData);
      // window.open("#/taskTreeView?id=" + mainTaskId, '_blank');

      this.$router.push({ name: 'taskTreeView', params: { id: mainTaskId } });

    }
  }
};
</script>
<style scoped>
.fullwidth {
  width: 100% !important;
  max-width: 100%;
}
</style>
<style>
.red {
  background: rgb(235, 77, 77) !important;
  color: whitesmoke !important;
}
.blue {
  background: rgb(59, 59, 163) !important;
  color: whitesmoke !important;
}
.orange {
  background: orange !important;
  color: white !important;
}
.green {
  background: rgb(49, 155, 49) !important;
  color: white !important;
}
.blue,
.orange,
.red,
.green {
  font-size: 13px;
  font-weight: 500;
  text-transform: capitalize;
}
.event-item {
  padding: 2px 0 2px 4px !important;
}
.handle {
  cursor: move !important;
  cursor: -webkit-grabbing !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/task/taskview.vue